import React from 'react'
import LandingHeader from "./LandingHeader"
import FooterOther from './FooterOther'


const PrivacyPolicy = () => {
    return (
        <div>
            <LandingHeader />
            <div className='max-w-[1300px] mx-auto mt-[50px] mb-[300px]'>
                <h2 className='font-semibold text-[30px]'>Privacy Policy</h2>
                <p>
                    This Privacy Policy outlines how Orden Technical Services Pvt. Ltd. (“we”, “our”, “us”) collects, uses,
                    stores, and protects the data you provide when using LexiLearn.in (the Platform). By accessing and
                    using the Platform, you agree to the terms of this Privacy Policy.
                </p>
                <div>
                    <ol type='1' className='list-decimal list-inside'>
                        <li>
                            Information We Collect
                            <p>We may collect and process the following types of information:</p>
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    Institutional data: Name of school/college, contact details, subscription details.
                                </li>
                                <li>
                                    User data: Names, classes/grades, reading levels, login credentials, and performance metrics of
                                    students and teachers using the platform.
                                </li>
                                <li>
                                    Usage data: Activity logs, time spent on modules, progress data, and technical information
                                    related to device/browser used.
                                </li>
                            </ul>
                        </li>

                        <li>
                            Purpose of Data Collection
                            <p>The information collected is used strictly for the following purposes:</p>
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    To personalize and enhance user learning experience.
                                </li>
                                <li>
                                    To generate reports and insights to support teaching and literacy improvement.
                                </li>
                                <li>
                                    To monitor system performance and improve platform functionality.
                                </li>
                                <li>
                                    To provide customer support and technical assistance.
                                </li>
                            </ul>
                        </li>
                        <li>
                            Data Confidentiality and NDA
                            <p>We are committed to maintaining strict confidentiality of all subscriber and user data. As part of our
                                subscription process, a Non-Disclosure Agreement (NDA) will be executed between Orden Technical
                                Services Pvt. Ltd. and each subscribing institution.
                            </p>

                            <p>
                                The NDA legally binds us to:
                            </p>
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    Not disclose any data, user information, or content uploaded/inputted by subscribers to any
                                    third party under any circumstances.
                                </li>
                                <li>
                                    Use subscriber data exclusively for the intended educational and performance-tracking purposes
                                    within the platform.
                                </li>
                            </ul>
                        </li>

                        <li>
                            Data Sharing and Disclosure
                            <p>
                                We do not sell, trade, rent, or share any personally identifiable information or institutional data with any
                                external parties, advertisers, or unauthorized affiliates.
                            </p>

                            <p>
                                We may, however, disclose information if:
                            </p>
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    Required by law or legal process.
                                </li>
                                <li>
                                    Necessary to enforce our Terms and Conditions or investigate violations.
                                </li>
                                <li>
                                    Needed to detect or prevent fraud, security, or technical issues.
                                </li>
                            </ul>
                        </li>

                        <li>
                            Data Security
                            <p>
                                We take data security seriously and implement appropriate technical and organizational measures to
                                protect your data from unauthorized access, loss, misuse, or alteration. These measures include:
                            </p>
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    Secure server environments
                                </li>
                                <li>
                                    Data encryption protocols
                                </li>
                                <li>
                                    Controlled access management
                                </li>
                            </ul>
                        </li>

                        <li>
                            User Access and Control
                            <p>
                                Authorized institutional administrators may request:
                            </p>
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    Access to student data
                                </li>
                                <li>
                                    Deletion or modification of any stored user information
                                </li>
                                <li>
                                    Reports and summaries of learning outcomes
                                </li>
                            </ul>

                            <p>
                                We process such requests in accordance with our internal policies and applicable data protection
                                regulations.
                            </p>
                        </li>

                        <li>
                            Cookies and Tracking
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    LexiLearn.in may use cookies or similar technologies to enhance the user experience, such as
                                    remembering login sessions or personalizing content. Users can disable cookies through their browser
                                    settings if they prefer.
                                </li>

                            </ul>
                        </li>

                        <li>
                            Retention of Data
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    We retain user data only for as long as necessary to fulfill the purposes for which it was collected. Upon
                                    termination of a subscription, data may be retained securely for a limited period before deletion, unless
                                    otherwise requested by the subscriber.
                                </li>

                            </ul>
                        </li>

                        <li>
                            Changes to this Privacy Policy
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    We reserve the right to update or amend this Privacy Policy at any time. All changes will be posted on
                                    this page with the updated effective date. Continued use of the Platform after changes implies your
                                    consent to the revised policy.
                                </li>

                            </ul>
                        </li>

                        <li>
                            Contact Us
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    If you have any questions, concerns, or requests regarding your data, please contact:
                                </li>
                                <p>Orden Technical Services Pvt. Ltd.</p>
                                <p>Email:lexilearn@orden.co.in</p>
                                <p>Address: D-196, Sector-63, Noida-201 307, India</p>

                            </ul>
                        </li>


                    </ol>
                </div>

            </div>
            <FooterOther />


        </div>
    )
}

export default PrivacyPolicy